import React from "react";
import { Route, Routes as RouterRoutes } from "react-router-dom";
import App from "./App";
import { PagePlaceholder, ProtectedRoute } from "./components";
import {
  BankDetails,
  BookedOrder,
  Customer,
  CustomerDetails,
  Dashboard,
  GstDetails,
  Login,
  Ndr,
  PersonalDetails,
  SellerAgreement,
  StepperContainer,
  Tracking,
  Billing,
  CodRemittance,
  CustomerCodRemittance,
  WeightDispute,
  WalletTransaction,
  Invoice,
  CreditNote,
  Reports,
  KycRequest,
  LoginCreditials,
  AppliedRates,
  PickupAddress,
  ShippingId,
  Blogs,
  CreateBlogs,
  Settings,
  CourierMgmt,
  Channel,
  EmployeeLogin,
  RateChart,
  Pincode,
  Support,
  Escalations,
  CallBackRequest,
  Banner,
  EditSingleRate,
  EditSinglePincode,
  Remarks,
  IccLogs,
  FetchOrderDetails,
  Careers,
  Contacts,
  UnauthorizedUser,
  PageNotFound,
  MyProfile,
} from "./pages";

const Routes = () => {
  return (
    <RouterRoutes>
      <Route path="login" element={<Login />} />
      <Route path="unauthorizedUser" element={<UnauthorizedUser />} />

      <Route element={<ProtectedRoute requiredPermission="Dashboard" />}>
        <Route path="/" element={<App />}>
          <Route path="my-profile" element={<MyProfile />} />
          <Route index element={<Dashboard />} />
          <Route
            element={<ProtectedRoute requiredPermission="Booked Orders" />}
          >
            <Route path="bookedOrders" element={<BookedOrder />} />
          </Route>
          <Route element={<ProtectedRoute requiredPermission="Tracking" />}>
            <Route path="tracking" element={<Tracking />} />
            <Route
              path="tracking/orderDetails"
              element={<FetchOrderDetails />}
            />
          </Route>
          <Route element={<ProtectedRoute requiredPermission="NDR" />}>
            <Route path="ndr" element={<Ndr />} />
          </Route>

          <Route element={<ProtectedRoute requiredPermission="Billing" />}>
            <Route path="billing" element={<Billing />}>
              <Route path="codRemittance" element={<CodRemittance />} />
              <Route path="walletTransaction" element={<WalletTransaction />} />
              <Route
                path="shippingCharges"
                element={<PagePlaceholder name="Shipping Charges" />}
              />
              <Route path="invoice" element={<Invoice />} />
              <Route path="creditNote" element={<CreditNote />} />
              <Route path="weightDispute" element={<WeightDispute />} />
            </Route>
          </Route>

          <Route element={<ProtectedRoute requiredPermission="Reports" />}>
            <Route path="reports" element={<Reports />} />
          </Route>

          <Route element={<ProtectedRoute requiredPermission="KYC Requests" />}>
            <Route path="kycRequests" element={<KycRequest />} />
          </Route>

          <Route element={<ProtectedRoute requiredPermission="Customers" />}>
            <Route path="customer" element={<Customer />} />
            <Route path="customer/details/:id" element={<CustomerDetails />}>
              <Route path="kycDetails" element={<StepperContainer />}>
                <Route path="personal" element={<PersonalDetails />} />
                <Route path="gst" element={<GstDetails />} />
                <Route path="bank" element={<BankDetails />} />
                <Route path="sellerAgreement" element={<SellerAgreement />} />
              </Route>
              <Route path="loginCredentials" element={<LoginCreditials />} />
              <Route path="appliedRate" element={<AppliedRates />} />
              <Route path="pickupAddress" element={<PickupAddress />} />
              <Route path="shippingId" element={<ShippingId />} />
              <Route path="codRemittance" element={<CustomerCodRemittance />} />
            </Route>
          </Route>

          <Route element={<ProtectedRoute requiredPermission="blogs" />}>
            <Route path="blogs" element={<Blogs />} />
          </Route>
          <Route element={<ProtectedRoute requiredPermission="blogs" />}>
            <Route path="blogs/createBlog" element={<CreateBlogs />} />
          </Route>
          <Route element={<ProtectedRoute requiredPermission="settings" />}>
            <Route path="settings" element={<Settings />}>
              <Route path="channel" element={<Channel />} />
              <Route path="rate" element={<RateChart />} />
              <Route path="rate/edit" element={<EditSingleRate />} />
              <Route path="employeeLogin" element={<EmployeeLogin />} />
              <Route path="courierMgmt" element={<CourierMgmt />} />
              <Route path="pincode" element={<Pincode />} />
              <Route path="pincode/edit" element={<EditSinglePincode />} />
            </Route>
          </Route>

          <Route element={<ProtectedRoute requiredPermission="Support" />}>
            <Route path="support" element={<Support />}>
              <Route path="escalations" element={<Escalations />} />
              <Route path="escalations/remarks/:id" element={<Remarks />} />
              <Route path="callbackRequests" element={<CallBackRequest />} />
              <Route path="career" element={<Careers />} />
              <Route path="contacts" element={<Contacts />} />
            </Route>
          </Route>
          <Route element={<ProtectedRoute requiredPermission="logs" />}>
            <Route path="logs" element={<IccLogs />} />
          </Route>
          <Route element={<ProtectedRoute requiredPermission="banners" />}>
            <Route path="banners" element={<Banner />} />
          </Route>
          <Route
            element={<ProtectedRoute requiredPermission="notifications" />}
          >
            <Route
              path="notifications"
              element={<PagePlaceholder name="Notifications" />}
            />
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<PageNotFound />} />
    </RouterRoutes>
  );
};

export default Routes;
